<div class="content-wrapper">
    <div class="membership-newsletters text-center">
        <div class="container">
            <form [formGroup]="emailForm">
                <h2 class="sec-title">Subscribe Newsletter</h2>
                <p class="sec-desc">Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.</p>
                <div class="form-group">
                  <input type="text" placeholder="Your-email@example.com"  class="form-control text-left" formControlName="email"/>
                  <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors.required" style="color: white">Please enter the email address where you'd like to receive our newsletter
                    </div>
                    <div *ngIf="f.email.errors.passwordCheck" style="color: white">Please enter your email address in the format yourname@example.com</div>
                  </div>
                  <button type="submit" class="btn btn-subs text-uppercase" (click)="subscribeNewsletterSubmit()" [disabled]="submitted">
                      SUBSCRIBE
                  </button>
                </div>
              </form>
        </div>
    </div>
    
</div>
<div class="enquiry-poup">
    <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
    </app-modal-pop-up>
  </div>